import type { AuditLogEntry } from '@shared/types/AuditLog';
import { sha256 } from '@shared/utils/hash';

/**
 * Audit trail immuable.
 * Chaque entrée est hashée et chaînée à la précédente pour détecter toute altération.
 * Conservation 10 ans (AUDCIF Art. 24).
 */
export class AuditTrailService {
  /** Génère le hash chaîné d'une entrée. */
  static async hashEntry(entry: AuditLogEntry, previousHash: string = ''): Promise<string> {
    const payload = JSON.stringify({
      id: entry.id,
      tenant_id: entry.tenant_id,
      date: entry.date,
      utilisateur: entry.utilisateur,
      action: entry.action,
      description: entry.description,
      previousHash,
    });
    return sha256(payload);
  }

  /** Vérifie l'intégrité d'une chaîne d'audit. */
  static async verifierIntegrite(
    entries: readonly AuditLogEntry[],
  ): Promise<{ ok: boolean; firstBrokenIdx?: number }> {
    let prev = '';
    for (let i = 0; i < entries.length; i++) {
      const e = entries[i]!;
      const expectedHash = await this.hashEntry(e, prev);
      if (e.hash && e.hash !== expectedHash) {
        return { ok: false, firstBrokenIdx: i };
      }
      prev = e.hash ?? expectedHash;
    }
    return { ok: true };
  }
}
